import { hearts } from "@app/rules";

/** A tap on a card while choosing the pass: on, off, and never a fourth (review 0025 S9). Pure. */
export function togglePass(selected: readonly string[], label: string): string[] {
  if (selected.includes(label)) return selected.filter((held) => held !== label);
  return selected.length >= hearts.PASS_COUNT ? [...selected] : [...selected, label];
}
